import { apiGet, apiPost, apiDelete } from "./client.js";

const BASE = "/api/v1/outbound-tasks";

export const listOutboundTasks = (status) => {
  const q = status ? `?status=${encodeURIComponent(status)}` : "";
  return apiGet(`${BASE}${q}`);
};

// Reset all completed/skipped tasks back to pending (keeps the list intact)
export const resetOutboundTasks = () => apiPost(`${BASE}/reset`, {});

// Wipe and regenerate all tasks from the seed logic
export const reseedOutboundTasks = () => apiPost(`${BASE}/reseed`, {});

// Wipe all tasks (no re-seed)
export const deleteAllOutboundTasks = () => apiDelete(BASE);
